import { FC } from 'react'
import { MdSettings } from 'react-icons/md'

import IconButton from '../../atoms/IconButton'
import PopupButton from '../../atoms/PopupButton'
import PageHeaderSettingsPopupContent from './PageHeaderSettingsPopupContent'

const PageHeaderSettings: FC = () => {
  return (
    <PopupButton
      popupComponent={<PageHeaderSettingsPopupContent />}
      buttonComponent={
        <IconButton noBorder className="text-hit-gray size-[25px] hover:bg-transparent">
          <MdSettings className="size-4" />
        </IconButton>
      }
      openOnHover
      classes={{
        Popup:
          'bg-white w-fit translate-x-[calc(-100%+24px)] shadow-popup! rounded-xl min-w-[163px] mt-0!',
      }}
      popupFixedProps={{ anchorOrigin: 'left' }}
      needToPassChildToggleProps={false}
      mouseLeaveActiveDirection="down"
    />
  )
}

export default PageHeaderSettings
